import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'

export interface BibliographyContentUpdateRequest {
  bibliographyContentId?: number
  details: BibliographyTagRegisterData[]
  revision: number
}

export function BibliographyContentUpdateRequestToJSON(
  value: BibliographyContentUpdateRequest
): any {
  return {
    bibliography_Content_id: value.bibliographyContentId ?? undefined,
    details: value.details.map(BibliographyTagRegisterDataToJSON),
    revision: value.revision
  }
}
